<template>
  <div v-if="!loading">
    <div class="output-format d-xl-flex justify-content-xl-evenly py-xl-3">
      <resume-global :objDTO="objDTO" />

      <resume-dados-sinistro
        :objDTO="objDTO"
        :events="events"
        :coverages="coverages"
      >
        <template #otherFields>
          <div>
            <span>BO:</span>
            {{ boletimOcorrenciaDesc() }}
          </div>
        </template>
      </resume-dados-sinistro>
    </div>

    <div class="output-format d-xl-flex justify-content-xl-evenly py-xl-3">
      <div class="output-group">
        <BensSinistrados
          :gdmTipos="gdmTipos"
          :isLoadingGdmTipos="false"
          :isReadonlyStage="true"
          :processoGDM="objDTO.ProcessoGDM"
          :maxDate="new Date()"
        />
      </div>
    </div>
    <div v-if="!loading" class="col-12 Aligner aligner-right">
      <button
        class="button-base-small btn-gray font-small mx-1"
        @click="voltar"
      >
        Voltar
      </button>
      <button
        class="button-base-small btn-green font-small mx-1"
        @click="finishAviso"
        :disabled="loading"
      >
        Concluir Aviso
      </button>
    </div>
  </div>
  <loading-state-f-s v-else />
</template>
<script>
import ResumeGlobal from '../ResumeGlobal.vue';
import LoadingStateFS from '../LoadingStateFS.vue';
import BensSinistrados from '../shared/BensSinistrados.vue';
import {
  getDescriptionFromArrayById,
  formatDate,
  handleAberturaResponseWithUploadDocuments,
} from '../../utils/helpers';
import { createAviso } from '../../api/formMethods';
import ResumeDadosSinistro from './shared/ResumeDadosSinistro.vue';
import { AREA_NEGOCIO } from '../../utils/constants';

export default {
  components: {
    ResumeGlobal,
    LoadingStateFS,
    BensSinistrados,
    ResumeDadosSinistro,
  },
  props: {
    objDTO: Object,
    events: Array,
    coverages: Array,
    gdmTipos: Array,
    riskUnits: Array,
    insuranceObjects: Array,
    optionYN: Array,
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    boletimOcorrenciaDesc() {
      return getDescriptionFromArrayById(
        this.optionYN,
        this.objDTO.Sinistro.BoletimOcorrencia.BoletimOcorrenciaOpcaoId,
        'Id'
      );
    },
    voltar() {
      this.$emit('back', 1);
    },
    async finishAviso() {
      this.loading = true;

      try{
        this.objDTO.FormAvisoId = 13;

      this.objDTO.Sinistro.SinistroData = formatDate(
        this.objDTO.Sinistro.SinistroData
      );
      this.objDTO.Sinistro.ApoliceDataInicio = formatDate(
        this.objDTO.Sinistro.ApoliceDataInicio
      );
      this.objDTO.Sinistro.ApoliceDataFim = formatDate(
        this.objDTO.Sinistro.ApoliceDataFim
      );
      this.objDTO.Sinistro.DataNascimento = formatDate(
        this.objDTO.Sinistro.DataNascimento
      );

      const response = await createAviso(this.objDTO, this.coverages);
      handleAberturaResponseWithUploadDocuments(
        response,
        AREA_NEGOCIO.AfinidadesDemaisProdutos
      );
      }
      catch (error) {
        this.loading = false;
        console.error(error);
      }
      finally {
        this.loading = false;
      }
    },
  },
};
</script>
